import { JourneyEditableState } from '@pushly/models/lib/enums/journeys'
import { getEditableState, JourneyEditableFields } from '@pushly/models/lib/utils/journey-editable-state'
import * as moment from 'moment-timezone'
import { StatusType } from '../../../enums/status-type'
import { isJourneyCompleted, Journey } from '../../../features/journeys/types/journey-api-response'

import type { IJourneySubscriberFcapRequest } from '@pushly/models/lib/structs/journeys/requests/request-interfaces'

export { getEditableState, JourneyEditableState }
export type { JourneyEditableFields }

type CalculatedStatusJourney = Pick<
    Journey,
    | 'date_start_utc'
    | 'date_start'
    | 'date_end_utc'
    | 'date_end'
    | 'status'
    | 'status_id'
    | 'date_completed_utc'
    | 'manually_completed'
>

export const getCalculatedStatus = (journey: CalculatedStatusJourney, format?: (status: string, journey: Pick<Journey, 'status'>) => string): string => {
    let computedStatus: string = StatusType.SCHEDULED.name

    const now = moment.utc()
    const dateStartValue = journey.date_start_utc || journey.date_start
    const dateStart = moment.tz(dateStartValue, 'utc')
    const dateEndValue = journey.date_end_utc || journey.date_end
    const dateEnd = !dateEndValue ? null : moment.tz(dateEndValue, 'utc')

    const editableState = getEditableState(journey)
    const editableStateIsCompleted = editableState === JourneyEditableState.COMPLETED

    const statusIsDraft = journey.status === StatusType.DRAFT.name
    const statusIsCancelled =
        journey.status === StatusType.CANCELLED.name || journey.status === StatusType.CANCELLING.name
    const statusIsCompleted =
        isJourneyCompleted(journey) || editableStateIsCompleted || (statusIsDraft && dateEnd && dateEnd <= now)

    if (statusIsCompleted) {
        computedStatus = StatusType.COMPLETED.name
    } else if (statusIsCancelled) {
        computedStatus = StatusType.CANCELLED.name
    } else if (statusIsDraft) {
        computedStatus = StatusType.DRAFT.name
    } else if (dateStart <= now) {
        computedStatus = StatusType.ACTIVE.name
    }

    return !format ? computedStatus : format(computedStatus, journey)
}

export const generateDefaultSubscriberFcap = (): IJourneySubscriberFcapRequest => ({
    criteria: {
        frequency: 1,
        window: 'days',
    },
    type: 'once_per_criteria',
})
